import React, { useEffect, useMemo } from "react";
import { withTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { clearAllAction } from "../../../../redux/actions.js";
// import { checkHealthAction } from "../../../../redux/reducers/apiReducers/getServicesReducer.js";
import { addToGoogleDataLayer } from "../../../../shared/const/utls.js";
import ContinueCancelButtons from "../../../../shared/components/ContinueCancelButtons.jsx";
import { Box, Link, Typography } from "@mui/material";
import StartHarpPageAccordion from "./StartHarpPageAccordion.jsx";
import WarningBox from "../../../../shared/components/WarningBox.jsx";

const StartHarpPageView = ({ t, i18n }) => {
  const navigate = useNavigate();
  const params = useParams();
  const dispatch = useDispatch();
  const disableGApush = useMemo(() => {
    return JSON.parse(params?.disableGA || false);
  }, [params]);
  const dates = useSelector(state => state.datesReducer)

  useEffect(() => {
    if (!disableGApush) {
      try {
        addToGoogleDataLayer("start-page", "Harp Application", i18n.language);
        window.scrollTo(0, 0);
      } catch (e) {
        console.log(e);
      }
    }
  }, [i18n.language, disableGApush]);

  useEffect(() => {
    if (i18n?.language === "en") {
      document.title =
        "See if you qualify for the grant - HARP - Government of Nova Scotia";
    } else {
      document.title =
        "Vérifiez si vous avez droit à la subvention – PAC – Gouvernement de la Nouvelle-Écosse";
    }
  }, [i18n.language]);

  const onNext = () => {
    try {
      // Validate then push to next route EX:
      // const healthCheckPromise = dispatch(checkHealthAction());
      // healthCheckPromise.then((result) => {
      //   if (result === "UP") {
      dispatch(clearAllAction());
      navigate(`/${i18n.language}${t("routes.pay_heat")}`);
      //   }
      // });
    } catch (e) {
      console.log(e);
    }
  };

  const warningContent = (<Typography variant="subtitle1" >{t("application_status.if_already_applied")}
    <Link
      style={{ cursor: "pointer", padding: '0px 6px' }}
      onClick={() =>
        navigate(`/${i18n.language}${t("routes.check_status")}`)
      }
    >
      {t("application_status.check_status_link")}
    </Link>

    {t("application_status.by_using_confirmation_number")}{" "}
  </Typography>)

  return (
    <div>
      <div className="container">
        <main>
          <article>
            <div className="row">
              <div className="col-sm-8 col-xs-12">
                <h1>{t("begin_page.title")}</h1>
              </div>
            </div>
            <StartHarpPageAccordion />

            <div>
              <WarningBox title={t('application_status.check_status_of_application')} content={warningContent} />
              <ContinueCancelButtons grayButton={!dates?.en?.isInYear} continueClick={onNext} isReversed={true} />
            </div>
          </article>
        </main>
      </div>
    </div >
  );
};

export default withTranslation("common")(StartHarpPageView);
